import React from 'react';
import errorGirl from '../../assets/images/404-vector-girl.png';
import ErrorPage from './ErrorPage';

export default class Error404 extends React.Component {
  render() {
    return (
      <ErrorPage
        errorGirl={errorGirl}
        title="404"
        subTitle="Ooops! We can&rsquo;t seem to find the page you are looking for."
      />
    );
  }
}
